export const validateReportName = (name) => {
  const trimmed = (name ?? "").trim();
  if (!trimmed) {
    return { valid: false, trimmed, error: "Report name is required" };
  }
  return { valid: true, trimmed, error: null };
};

export const isReportNameInUse = (name, savedReports, excludeReportId) => {
  const normalized = name.trim().toLowerCase();
  return (savedReports ?? []).some((report) => {
    if (!report.displayName) return false;
    if (excludeReportId && report.internalName === excludeReportId) {
      return false;
    }
    return report.displayName.trim().toLowerCase() === normalized;
  });
};

export const extractApiErrorMessage = (error, fallback) => {
  const raw = error?.data ?? error?.message;
  if (typeof raw === "string") return raw;
  if (raw != null) return JSON.stringify(raw);
  return fallback;
};
